function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.10976 10.4909C9.04573 10.4817 8.96341 10.4817 8.89024 10.4909C7.28049 10.436 6 9.1189 6 7.5C6 5.84451 7.33537 4.5 9 4.5C10.6555 4.5 12 5.84451 12 7.5C11.9909 9.1189 10.7195 10.436 9.10976 10.4909Z",
  fill: "orange"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.055 14.535C12.72 15.7575 10.95 16.5 9 16.5C7.05 16.5 5.28 15.7575 3.945 14.535C4.02 13.83 4.47 13.14 5.2725 12.6C7.3275 11.235 10.6875 11.235 12.7275 12.6C13.53 13.14 13.98 13.83 14.055 14.535Z",
  fill: "orange"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z",
  stroke: "orange",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgOrangePatientFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 -3 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangePatientFlag);
export default __webpack_public_path__ + "static/media/orange-patient-flag.b8eee43f.svg";
export { ForwardRef as ReactComponent };